<nav id="navbar-breadcrumbs">
  <stb-breadcrumbs
    [breadcrumbs]="breadcrumbItems()"
    [useEvents]="false"
    [backText]="'breadcrumbs.backButtonText' | fms"
    (clicked)="navigateBack()"
  ></stb-breadcrumbs>
</nav>
